export default class SubscribePopup {
    constructor () {
        this.toggler = document.querySelector('.js-open-subscribe-modal.subscribe-bar');
        if (this.toggler) {
            this.addListeners();
        }
    }
    addListeners() {
        const that = this;
        this.toggler.addEventListener('click', function (e) {
            if ((e.target.matches('.subscribe-bar.js-open-subscribe-modal')
                || e.target.matches('.subscribe-bar__toggle') || e.target.matches('.subscribe-bar__toggle *')
            ) && !this.classList.contains('show')) {
                this.classList.add('show');
                document.body.classList.add('hidden-overflow');
            } else if (e.target.matches('.subscribe-bar.js-open-subscribe-modal.show') || e.target.matches('.subscribe-bar__toggle')) {
                that.hidePopup();
            }
        });
    }
    hidePopup() {
        this.toggler.classList.remove('show');
        document.body.classList.remove('hidden-overflow');
    }
}